import React from 'react';

const RecentActivityCard = ({ activities }) => {
    return (
        <div className="recent-activity-card">
            <div className="card-title">Activité récente des utilisateurs</div>
            <div className="activity-list">
                {activities.map(activity => (
                    <div key={activity.id} className="activity-item">
                        <img src={activity.user.avatar} alt={activity.user.name} className="activity-avatar" />
                        <div className="activity-details">
                            <strong>{activity.user.name}</strong> {activity.text}
                        </div>
                    </div>
                ))}
                {activities.length === 0 && <div className="no-data">Aucune activité récente.</div>}
            </div>
        </div>
    );
};

export default RecentActivityCard; 